import urls from "../utils/urls"
import { post} from '../utils/http'
const state= {
    
    result:{},
  
    code:0
    
}
const mutations={
   

    getUserRecharge(state,value){
        
        
       
        post(urls.admin.recharge.index,value).then((result)=>{
          
          
          
          state.result=result
        
       
        
       
           
        });
        
    },
   

    addRecharge(state,value){
        
        
       
        post(urls.admin.recharge.add,value).then((result)=>{
          
          
          
          state.result=result
        
       
        
       
           
        });
        
    },
    editRecharge(state,value){
        
        
      
        post(urls.admin.recharge.edit,value).then((result)=>{
          
          
          
          state.result=result
        
       
        
       
           
        });
        
    },
  
    
   

    

}
const  actions={

    
    getUserRechargeAction(context,value){
       
        context.commit("getUserRecharge",value)
       
    },
  
    addRechargeAction(context,value){
       
        context.commit("addRecharge",value)
       
    },
   
    editRechargeAction(context,value){
       
        context.commit("editRecharge",value)
       
    },

    
    

}

export default {state,mutations,actions}